/**
 * GraphQL queries and hooks — search pillar.
 * Split from graphql/queries.ts (issue #1409).
 */

import { gql } from '@apollo/client';
import { useLazyQuery, type LazyQueryResultTuple } from '@apollo/client/react';
import type { SearchResultsConnection, SearchableEntityType } from '../types/search';

export const SEARCH_QUERY = gql`
  query Search(
    $query: String!
    $entityTypes: [SearchableEntityType!]
    $limit: Int
    $cursor: String
  ) {
    search(query: $query, entityTypes: $entityTypes, limit: $limit, cursor: $cursor) {
      results {
        entityId
        entityType
        name
        description
        url
      }
      totalCount
      cursor
    }
  }
`;

export interface SearchQueryVariables {
  query: string;
  entityTypes?: SearchableEntityType[];
  limit?: number;
  cursor?: string;
}

export function useSearchLazy(): LazyQueryResultTuple<
  { search: SearchResultsConnection },
  SearchQueryVariables
> {
  return useLazyQuery<{ search: SearchResultsConnection }, SearchQueryVariables>(SEARCH_QUERY, {
    fetchPolicy: 'network-only',
  });
}

// ─── Maturity Model ────────────────────────────────────────────────────────
